import ApiIntegrationGitlab from "../../../../../core/gd/api/integrations/gitlab";

export default async function gitlabIntegration_Disable (){
    try{
        await ApiIntegrationGitlab.disableIntegration()

        gd.modal.hide();
        gd.modules.gitlab._isEnabled = false

        // gd.goTo('o/'+gd.companyId+'/settings/integrations');
        gd.getApp().start();
    }
    catch (e: any){
        console.log(e)
        gd.modal.hide();
    }
}